import { render, staticRenderFns } from "./GeneralDropdowns.vue?vue&type=template&id=62c54046&"
import script from "./GeneralDropdowns.vue?vue&type=script&lang=js&"
export * from "./GeneralDropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xampp\\htdocs\\lifeline-donation-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c54046')) {
      api.createRecord('62c54046', component.options)
    } else {
      api.reload('62c54046', component.options)
    }
    module.hot.accept("./GeneralDropdowns.vue?vue&type=template&id=62c54046&", function () {
      api.rerender('62c54046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/GeneralDropdowns.vue"
export default component.exports